// auth.js - 认证相关工具函数

// 保存token到localStorage
export function setToken(token) {
  localStorage.setItem('token', token)
}

// 从localStorage获取token
export function getToken() {
  return localStorage.getItem('token')
}

// 删除localStorage中的token
export function removeToken() {
  localStorage.removeItem('token')
}

// 保存用户信息到localStorage
export function setUserInfo(user) {
  localStorage.setItem('userInfo', JSON.stringify(user))
}

// 从localStorage获取用户信息
export function getUserInfo() {
  const userInfo = localStorage.getItem('userInfo')
  return userInfo ? JSON.parse(userInfo) : null
}

// 删除localStorage中的用户信息
export function removeUserInfo() {
  localStorage.removeItem('userInfo')
}

// 清除所有认证信息
export function clearAuth() {
  removeToken()
  removeUserInfo()
}

// 判断用户是否已登录（有 token 且有 userInfo）
export function isLoggedIn() {
  return !!getToken() && !!getUserInfo()
}

/**
 * 判断 token 是否有效（存在且未过期）
 * JWT payload 中的 exp 为秒级时间戳，过期则视为无效，需重新登录
 */
export function isTokenValid() {
  const token = getToken()
  if (!token) return false
  try {
    const payload = token.split('.')[1]
    if (!payload) return false
    const decoded = JSON.parse(decodeURIComponent(escape(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))))
    const exp = decoded.exp
    if (exp == null || typeof exp !== 'number') return true // 无 exp 时仅凭存在即视为有效，由后端校验
    return exp * 1000 > Date.now()
  } catch (e) {
    return false
  }
}